<template>
	<ui-validate :value="errorText" :novalidate="novalidate" :nomessage="nomessage" :verifying="verifying" v-if="!view">
		<el-upload :action="action" :accept="accept" :headers="headers" :on-success="onSuccess" :before-remove="beforeRemove" :on-remove="onRemove" :on-preview="onPreview"
			:file-list="fileList">
			<el-button size="small" icon="el-icon-upload2" type="primary">点击上传</el-button>
			<!--<div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div>-->
		</el-upload>
	</ui-validate>
	<div v-else>
		<div v-for="file in selfFileList" class="uimaker-attachments">
			<ul class="el-upload-list el-upload-list--text" @click="filePreview(file)">
				<li tabindex="0" class="el-upload-list__item is-success">
					<a class="el-upload-list__item-name">
						<i class="el-icon-document"></i>{{file.name}}</a>
				</li>
			</ul>
		</div>
	</div>
</template>

<script>
import uiValidate from './ui-validate.vue'
import store from '@/store'
import qs from 'qs'

export default {
	name:'ui-attachment',
	props:{
		value:{type:String,default:''},
		required:{type:Boolean,default:false},
		view:{type:Boolean,default:false},
		novalidate:{type:Boolean,default:false},
		nomessage:{type:Boolean,default:false},
		multiple:{type:Boolean,default:false},
		accept:{type:String},
		uploadPath:{type:String,default:'/attach/upload'},
		filePath:{type:String,default:'/attach/download'},
		responseValueField:{type:String,default:'data.id'},
		responseError:{type:Function,default:(response)=>{
			return response.code!==0;
		}},
		headers:{type:Object,default:()=>{return {token:store.state.app.token}}},
	},
	data(){
		return {
			errorText:'',
			resourcePath:WEBCONFIG.resourcePath,
			action:WEBCONFIG.resourcePath+this.uploadPath,
			verifying:false,
			fileList:[],
			selfFileList:[],
		};
	},
	computed:{
	},
	created(){
		if(this.value!='')
			this.setFileList(this.value);
	},
	mounted(){
	},
	methods:{
		validate(){
			this.verifying=true;
			var isValid=false;
			if(this.required&&!this.view&&(this.value===''||this.value==null)){
				this.errorText='必填项不能为空';
			}
			else{
				this.errorText='';
				isValid=true;
			}
			return isValid;
		},
		getMessage(){
			return this.errorText;
		},
		getResponseValue(response){
			var names=this.responseValueField.split('.');
			var obj=response;
			for(var i=0;i<names.length;i++){
				obj=obj[names[i]];
				if(obj==null)
					break;
			}
			return obj;
		},
		setResponseValue(val){
			var names=this.responseValueField.split('.');
			var result={};
			var obj=result;
			for(var i=0;i<names.length;i++){
				if(i==names.length-1){
					obj[names[i]]=val;
					break;
				}
				obj[names[i]]={};
				obj=obj[names[i]];
			}
			return result;
		},
		onSuccess(response, file, fileList) {
			if(response==''||this.responseError(response)){
				this.$msgbox('上传失败').catch(e=>{});
				return;
			}
			if(!this.multiple){
				fileList=fileList.slice(-1);
			}
			this.selfFileList=fileList;
			let value=fileList.map(p=>this.getResponseValue(p.response)).join(',');
			this.$emit('input',value);
			this.$emit('change',value,response.data);
		},
		onRemove(file, fileList){
			this.selfFileList=fileList;
			let value=fileList.map(p=>this.getResponseValue(p.response)).join(',');
			this.$emit('input',value);
			this.$emit('change',value,'');
		},
		onPreview(file) {
			var val=this.getResponseValue(file.response);
			window.open(this.resourcePath+this.filePath+(val[0]=='/'?val:('/'+val))+'?'+qs.stringify(this.headers));
		},
		filePreview(file) {
			var val=this.getResponseValue(file.response);
			window.open(this.resourcePath+this.filePath+(val[0]=='/'?val:('/'+val))+'?'+qs.stringify(this.headers));
		},
		beforeRemove(file, fileList) {
			return this.$confirm(`确定移除 ${ file.name }？`);
		},
		setFileList(val){
			this.selfFileList=[];
			if(val!=''&&typeof val=='string'){
				var vals=val.split(',');
				for(var i=0;i<vals.length;i++){
					if(this.selfFileList.filter(p=>this.getResponseValue(p.response)==vals[i]).length==0){
						var valInfos=vals[i].split(/\/|\\/);
						this.selfFileList.push({name:valInfos[valInfos.length-1],response:this.setResponseValue(vals[i])/*,url:this.resourcePath+vals[i]*/});
					}
				}
				this.fileList=this.selfFileList;
			}
			else if(typeof val=='object'){
				for(var i=0;i<val.length;i++){
					if(this.selfFileList.filter(p=>this.getResponseValue(p.response)==val[i].id).length==0){
						this.selfFileList.push({name:val[i].originalName,response:this.setResponseValue(val[i].id)/*,url:this.resourcePath+val[i].id*/});
					}
				}
				this.fileList=this.selfFileList;
			}
			else{
				this.fileList=[];
			}
		}
	},
	watch:{
		value(val){
			this.setFileList(val);
			if(this.verifying)
				this.validate();
		},
	},
	components: {
        uiValidate
    }
}
</script>

<style>
</style>